import React, { useRef } from 'react'
import lang from '../utils/languageConstant';
import { useDispatch, useSelector } from 'react-redux';
import openai from '../utils/openai';
import { API_OPTIONS } from '../utils/constants';
import { addGptMovieResult } from '../utils/gptSlice';

const GptSearchBar = () => {
    const languageKey  = useSelector(store=> store.config.lang);
    const searchText = useRef(null);
    const dispatch = useDispatch();
   //movie search in TMDB
    const searchMovieTMDB = async (movie) => {
        const data = await fetch(`https://api.themoviedb.org/3/search/movie?query=${movie}&include_adult=false&language=en-US&page=1`, API_OPTIONS);
        const json = await data.json();
        return json.results;
    }
   
    const handleGptSearchClick = async () =>{
        console.log(searchText.current.value);
        //make an api call to gpt api and get movie results

        const gptQuery = "Act as a Movie Recommendation System and suggest some movies for the query " + searchText.current.value+ ". only give me names of 5 movies, comma seperated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya";
        const gptResults = await openai.chat.completions.create({
            messages: [{ role: 'user', content: gptQuery }],
            model: 'gpt-3.5-turbo-0125',
          });    
        
        if(!gptResults.choices) {//TODO : write error handling
        }
        console.log(gptResults.choices?.[0]?.message.content);
        const gptMovies = gptResults.choices?.[0]?.message.content.split(", ");
        //For each movie I will seaarch TMDB API
        const promiseArray = gptMovies.map((movie)=> searchMovieTMDB(movie)); 
        const tmdbResults = await Promise.all(promiseArray);
        
        dispatch(addGptMovieResult({movieNames: gptMovies,movieResults:tmdbResults}));
    }   
    
    return (
    <div className='pt-[35%] md:pt-[10%] flex justify-center'>
        <form className="w-full md:w-1/2 bg-black grid grid-cols-12 rounded-b-lg bg-opacity-45" onSubmit={(e)=> e.preventDefault()}>
            <input
            ref={searchText} 
            type="text" className="p-4 m-4 col-span-9" placeholder={lang[languageKey].gptSearchPlaceholder}/>
            <button className="py-2 m-4 px-4 col-span-3 bg-red-700 text-white rounded-lg" onClick={handleGptSearchClick}>{lang[languageKey].search}</button>
        </form>
    </div>
  )
}

export default GptSearchBar;